<template>
    <div class="blockuser" v-if="nseen">
        <div class="notify warning">
            <div>
                <span class="closewarning" @click="close">
                    <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                        <path fill="#000000" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                    </svg>
                </span>
                <span v-html="msg"></span>
            </div>
        </div>
    </div>
</template>
<script>

export default {
  data () {
    return {
      nseen: false,
      msg: ''
    }
  },
  methods: {
    load (msg) {
      this.msg = msg
      this.nseen = true
    },
    close () {
      this.nseen = false
    }
  }
}
</script>
